import { EntityModel } from '@/interfaces'
import {
  ALL_API_KEYS_QUERY,
  CREATE_API_KEY_MUTATION,
  DELETE_API_KEY_MUTATION,
  FORCE_DELETE_API_KEY_MUTATION,
  SINGLE_API_KEY_QUERY,
  UPDATE_API_KEY_MUTATION,
} from './graphql'
import rbacRoleEntity from '@/entities/rbacRole/entity'

const apiKeyModel: EntityModel = {
  name: 'apiKey',
  namePlural: 'apiKeys',
  uniqueName: 'apiKey',
  uniqueNamePlural: 'apiKeys',
  path: 'iam/api_key',
  baseUrl: '/iam/api_keys',
  translationPrefix: 'entities:apiKey.',
  getDisplayName: (values: any) => {
    return 'API_KEY'
  },
  gql: {
    getAll: ALL_API_KEYS_QUERY,
    getSingle: SINGLE_API_KEY_QUERY,
    create: CREATE_API_KEY_MUTATION,
    update: UPDATE_API_KEY_MUTATION,
    delete: DELETE_API_KEY_MUTATION,
    forceDelete: FORCE_DELETE_API_KEY_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:apiKey.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    key: {
      name: 'key',
      label: 'entities:apiKey.attributes.key.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'password',
      validationType: 'string',
      validations: [],
    },
    role: {
      name: 'role',
      label: 'entities:apiKey.attributes.role.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return rbacRoleEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default apiKeyModel
